var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _vm._m(0),
      _c("div", { staticClass: "contentDetails" }, [
        _c(
          "div",
          { staticClass: "box" },
          [
            _vm.routeQuery.afterType == 0
              ? _c("Steps", { attrs: { stepInfo: _vm.afterSaleNode } })
              : _vm._e(),
            _vm.routeQuery.afterType == 1
              ? _c("Steps1", { attrs: { stepInfo: _vm.afterSaleNode } })
              : _vm._e(),
            _vm.routeQuery.afterType == 2
              ? _c("Steps2", { attrs: { stepInfo: _vm.afterSaleNode } })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "contentDetails",
          staticStyle: { display: "flex", "justify-content": "space-between" },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "18px",
                "font-family": "PingFang SC",
                "font-weight": "400",
                "line-height": "30px",
                color: "#333333",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("img", {
                    staticStyle: { "margin-right": "8px" },
                    attrs: { src: _vm.statusImg.close },
                  }),
                  _c("span", { staticClass: "boldSize" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.orderMessage.status == 1 ? "待审核" : "") ||
                            (_vm.orderMessage.status == 3
                              ? "申请已通过，待买家寄回商品"
                              : "") ||
                            (_vm.orderMessage.status == 2 ? "驳回理由" : "") ||
                            (_vm.orderMessage.status == 4
                              ? "买家已寄回，待卖家签收"
                              : "") ||
                            (_vm.orderMessage.status == 7
                              ? "售后申请已取消"
                              : "") ||
                            (_vm.orderMessage.status == 5
                              ? "买家寄回商品已签收，待卖家换货寄出"
                              : "") ||
                            (_vm.orderMessage.status == 6
                              ? "卖家已寄出换货商品，待买家签收"
                              : "") ||
                            (_vm.orderMessage.status == 8 &&
                            _vm.orderMessage.afterType == 0
                              ? "已退款"
                              : "") ||
                            (_vm.orderMessage.status == 8 &&
                            _vm.orderMessage.afterType == 1
                              ? "售后完成，已成功退款"
                              : "") ||
                            (_vm.orderMessage.status == 8 &&
                            _vm.orderMessage.afterType == 2
                              ? "买家已签收"
                              : "")
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
              _vm.orderMessage.status == 1
                ? _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _vm._v(" 请及时审核 "),
                  ])
                : _vm._e(),
              _vm.orderMessage.status == 2
                ? _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _vm._v(" " + _vm._s(_vm.orderMessage.approveRemark) + " "),
                  ])
                : _vm._e(),
              _vm.orderMessage.status == 3
                ? _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _c("div", [_vm._v("买家寄回中...")]),
                  ])
                : _vm._e(),
              _vm.orderMessage.status == 7
                ? _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _c("div", [_vm._v("用户已手动取消售后申请！")]),
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#666666", "font-size": "16px" },
                      },
                      [
                        _vm._v(
                          " 时间：" + _vm._s(_vm.orderMessage.createdTime) + " "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.orderMessage.status == 4
                ? _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _vm.backInfo
                      ? _c("div", [
                          _vm._v(
                            " 物流公司：" +
                              _vm._s(_vm.backInfo.logisticsCompanyLabel) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _vm.backInfo
                      ? _c("div", { staticStyle: { "margin-top": "10px" } }, [
                          _vm._v(
                            " 物流订单：" +
                              _vm._s(_vm.backInfo.logisticsNumber) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.orderMessage.status == 6
                ? _c("div", [
                    _c("div", [_vm._v("出货信息")]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "rgb(97, 144, 237)",
                            "font-size": "16px",
                          },
                        },
                        [_vm._v("运输中")]
                      ),
                      _vm.backInfo
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#666666",
                                "font-size": "16px",
                                "margin-left": "10px",
                              },
                            },
                            [
                              _vm._v(
                                " 物流公司：" +
                                  _vm._s(_vm.backInfo.logisticsCompanyLabel) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.backInfo
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-left": "10px",
                                color: "#666666",
                                "font-size": "16px",
                              },
                            },
                            [
                              _vm._v(
                                " 物流订单：" +
                                  _vm._s(_vm.backInfo.logisticsNumber) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm.orderMessage.status == 5
                ? _c("div", [
                    _c("div", [_vm._v("出货信息")]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          color: "rgb(97, 144, 237)",
                          "font-size": "16px",
                        },
                      },
                      [_vm._v(" 等待寄出换货 ")]
                    ),
                  ])
                : _vm._e(),
              _vm.orderMessage.status == 8 && _vm.orderMessage.afterType == 0
                ? _c("div", [_c("div", [_vm._v("退款金额已退回买家账户！")])])
                : _vm._e(),
              _vm.orderMessage.status == 8 && _vm.orderMessage.afterType == 2
                ? _c("div", [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _vm.backInfo
                        ? _c("div", [
                            _vm._v(
                              " 物流公司：" +
                                _vm._s(_vm.backInfo.logisticsCompanyLabel) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.backInfo
                        ? _c(
                            "div",
                            { staticStyle: { "margin-left": "10px" } },
                            [
                              _vm._v(
                                " 物流订单：" +
                                  _vm._s(_vm.backInfo.logisticsNumber) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm.orderMessage.status == 8 && _vm.orderMessage.afterType == 1
                ? _c("div", [
                    _c("div", [
                      _vm._v(
                        "完成时间：" + _vm._s(_vm.orderMessage.completeTime)
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm.routeQuery.afterType == 0
            ? _c("div", { staticClass: "logisticsBtn" })
            : _vm._e(),
          _vm.routeQuery.afterType == 1
            ? _c(
                "div",
                { staticClass: "logisticsBtn" },
                [
                  _vm.orderMessage.status == 1
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: { click: _vm.applyDialog },
                        },
                        [_vm._v("审核申请")]
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 3
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: {
                            click: function ($event) {
                              return _vm.outGoods("fedit")
                            },
                          },
                        },
                        [_vm._v("填写退货单号")]
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 4
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: {
                            click: function ($event) {
                              return _vm.stock("five")
                            },
                          },
                        },
                        [_vm._v("确认收货")]
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 6
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: {
                            click: function ($event) {
                              return _vm.stock("user")
                            },
                          },
                        },
                        [_vm._v("确认收货")]
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 4 || _vm.orderMessage.status == 8
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: {
                            click: function ($event) {
                              return _vm.examine(1)
                            },
                          },
                        },
                        [_vm._v("查看物流")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.routeQuery.afterType == 2
            ? _c(
                "div",
                { staticClass: "logisticsBtn" },
                [
                  _vm.orderMessage.status == 1
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: { click: _vm.applyDialog },
                        },
                        [_vm._v("审核申请")]
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 4
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: {
                            click: function ($event) {
                              return _vm.stock("five")
                            },
                          },
                        },
                        [_vm._v("确认收货")]
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 6
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: {
                            click: function ($event) {
                              return _vm.stock("user")
                            },
                          },
                        },
                        [_vm._v("确认收货")]
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 5
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: {
                            click: function ($event) {
                              return _vm.outGoods("delivery")
                            },
                          },
                        },
                        [_vm._v("寄出换货")]
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 4
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: {
                            click: function ($event) {
                              return _vm.examine(1)
                            },
                          },
                        },
                        [_vm._v("查看物流")]
                      )
                    : _vm._e(),
                  _vm.orderMessage.status == 6 || _vm.orderMessage.status == 8
                    ? _c(
                        "el-button",
                        {
                          staticClass: "whiteBtn",
                          on: {
                            click: function ($event) {
                              return _vm.examine(2)
                            },
                          },
                        },
                        [_vm._v("查看物流")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "contentDetails" }, [
        _c("div", { staticClass: "title" }, [_vm._v("订单信息")]),
        _c("div", { staticClass: "order_details" }, [
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单编号"),
              ]),
              _vm.orderMessage.orderInfo
                ? _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orderInfo.orderNo
                          ? _vm.orderMessage.orderInfo.orderNo
                          : "-"
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单类型"),
              ]),
              _vm.orderMessage.orderInfo
                ? _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orderInfo.orderTypeLabel
                          ? _vm.orderMessage.orderInfo.orderTypeLabel
                          : "-"
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _vm._m(1),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("支付时间"),
              ]),
              _vm.orderMessage.orderInfo
                ? _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orderInfo.payTime
                          ? _vm.orderMessage.orderInfo.payTime
                          : "-"
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "remarkMessage" }, [
          _c("div", { staticClass: "remarkMessage_remark" }, [
            _c("div", { staticClass: "remarkMessage_remark_item" }, [
              _c("span", { staticClass: "fourteenTitle" }, [
                _vm._v("备注信息"),
              ]),
              _vm.orderMessage.orderInfo
                ? _c("span", { staticClass: "fourteenDetails" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orderInfo.userRemark
                          ? _vm.orderMessage.orderInfo.userRemark
                          : "暂无备注 "
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "contentDetails" }, [
        _c("div", { staticClass: "title" }, [_vm._v("购买信息")]),
        _c("div", { staticClass: "contentDetails_box" }, [
          _c("div", { staticClass: "contentDetails_item" }, [
            _c("div", { staticClass: "title_too" }, [_vm._v("收货信息")]),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("收货人"),
                ]),
                _vm.orderMessage.orderInfo
                  ? _c("span", { staticClass: "details_value fourteen" }, [
                      _vm._v(
                        _vm._s(
                          _vm.orderMessage.orderInfo.postName
                            ? _vm.orderMessage.orderInfo.postName
                            : "-"
                        )
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("联系方式"),
                ]),
                _vm.orderMessage.orderInfo
                  ? _c("span", { staticClass: "details_value fourteen" }, [
                      _vm._v(
                        _vm._s(
                          _vm.orderMessage.orderInfo.postPhone
                            ? _vm.orderMessage.orderInfo.postPhone
                            : "-"
                        )
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "details_item addressWidth" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("收货地址"),
                ]),
                _vm.orderMessage.orderInfo
                  ? _c("span", { staticClass: "details_value fourteen" }, [
                      _vm._v(
                        _vm._s(_vm.orderMessage.orderInfo.postDistrictAddress) +
                          " " +
                          _vm._s(_vm.orderMessage.orderInfo.postAddress)
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "borderWire" }),
          _c("div", { staticClass: "contentDetails_item" }, [
            _c("div", { staticClass: "title_too" }, [_vm._v("买家信息")]),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("客户姓名"),
                ]),
                _vm.orderMessage.orderInfo
                  ? _c("span", { staticClass: "details_value fourteen" }, [
                      _vm._v(
                        _vm._s(
                          _vm.orderMessage.orderInfo.userName
                            ? _vm.orderMessage.orderInfo.userName
                            : "-"
                        )
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("客户电话"),
                ]),
                _vm.orderMessage.orderInfo
                  ? _c("span", { staticClass: "details_value fourteen" }, [
                      _vm._v(
                        _vm._s(
                          _vm.orderMessage.orderInfo.userPhone
                            ? _vm.orderMessage.orderInfo.userPhone
                            : "-"
                        )
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "borderWire" }),
          _c("div", { staticClass: "contentDetails_item" }, [
            _c("div", { staticClass: "title_too" }, [_vm._v("来源平台")]),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("来源平台"),
                ]),
                _vm.orderMessage.orderInfo
                  ? _c("span", { staticClass: "details_value fourteen" }, [
                      _vm._v(
                        _vm._s(
                          _vm.orderMessage.platformLabel
                            ? _vm.orderMessage.platformLabel
                            : "-"
                        )
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "contentDetails" },
        [
          _vm._m(2),
          _c(
            "el-table",
            {
              staticClass: "goodsMessage",
              attrs: {
                data: _vm.orderDetailList1,
                "header-cell-style": {
                  background: "#fafafa",
                  color: "#333333",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "updatedTime",
                  label: "商品信息",
                  headerAlign: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "left" } }, [
                          _c("p", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  props.row.goodsName
                                    ? props.row.goodsName
                                    : "-"
                                )
                              ),
                            ]),
                            props.row.goodsType == 3
                              ? _c("span", { staticClass: "gift" }, [
                                  _vm._v("赠品"),
                                ])
                              : _vm._e(),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                props.row.goodsSkuName
                                  ? props.row.goodsSkuName
                                  : "-"
                              )
                            ),
                          ]),
                          _c("p", [
                            _c(
                              "span",
                              { staticStyle: { "padding-right": "10px" } },
                              [_vm._v("商品编码")]
                            ),
                            _vm._v(
                              _vm._s(
                                props.row.goodsSkuNo
                                  ? props.row.goodsSkuNo
                                  : "-"
                              ) + " "
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "authListStr",
                  label: "单价/数量",
                  "header-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "right" } }, [
                          _c("p", [
                            _vm._v(
                              "￥ " +
                                _vm._s(Number(props.row.retailPrice).toFixed(2))
                            ),
                          ]),
                          _c("p", [
                            _vm._v("× " + _vm._s(props.row.afterQuantity)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "authListStr",
                  label: "运费",
                  "header-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "right" } }, [
                          _vm._v(
                            " ￥ " +
                              _vm._s(
                                Number(props.row.freightAmount).toFixed(2)
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "authListStr",
                  label: "小计",
                  "header-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticStyle: { "text-align": "right" } }, [
                          _vm._v(
                            " ￥ " +
                              _vm._s(
                                Number(
                                  props.row.afterQuantity *
                                    props.row.retailPrice
                                ).toFixed(2)
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("div", { staticClass: "fourteenDetails_title" }, [
            _vm._v("优惠信息"),
          ]),
          _vm.orderMessage.discountLabel
            ? _c("div", [
                _c("p", [_vm._v(_vm._s(_vm.orderMessage.discountLabel))]),
              ])
            : [
                _c(
                  "div",
                  {
                    staticClass: "fourteenDetails",
                    staticStyle: {
                      "margin-top": "12px",
                      "border-bottom": "1px solid #ededed",
                      "padding-bottom": "20px",
                    },
                  },
                  [_vm._v(" 无优惠 ")]
                ),
              ],
          _vm.routeQuery.afterType == 0 && _vm.orderDetailList2.length != 0
            ? _c("div", { staticClass: "titleBtn" }, [
                _c(
                  "div",
                  {
                    staticClass: "title",
                    staticStyle: {
                      "margin-bottom": "20px",
                      "margin-top": "20px",
                    },
                  },
                  [_vm._v(" 赠品商品 ")]
                ),
              ])
            : _vm._e(),
          _vm.routeQuery.afterType == 0 && _vm.orderDetailList2.length != 0
            ? _c(
                "el-table",
                {
                  staticClass: "goodsMessage",
                  attrs: {
                    data: _vm.orderDetailList2,
                    "header-cell-style": {
                      background: "#fafafa",
                      color: "#333333",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "updatedTime", label: "商品信息" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("p", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          props.row.goodsName
                                            ? props.row.goodsName
                                            : "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        props.row.goodsSkuName
                                          ? props.row.goodsSkuName
                                          : "-"
                                      )
                                    ),
                                  ]),
                                  _c("p", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "padding-right": "10px",
                                        },
                                      },
                                      [_vm._v("商品编码")]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        props.row.goodsSkuNo
                                          ? props.row.goodsSkuNo
                                          : "-"
                                      ) + " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2239294710
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "authListStr",
                      label: "单价/数量",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "￥ " +
                                        _vm._s(
                                          Number(props.row.retailPrice).toFixed(
                                            2
                                          )
                                        )
                                    ),
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      "× " + _vm._s(props.row.afterQuantity)
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1907032316
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "authListStr",
                      label: "小计",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm._v(
                                    " ￥ " +
                                      _vm._s(
                                        Number(
                                          props.row.afterQuantity *
                                            props.row.retailPrice
                                        ).toFixed(2)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2540759112
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "total_prices" }, [
            _vm.orderMessage.orderInfo && _vm.orderMessage.afterType == 0
              ? _c(
                  "span",
                  { staticStyle: { color: "#666666", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "商品总价：￥" +
                        _vm._s(
                          Number(
                            _vm.orderMessage.orderInfo.goodsAmount
                          ).toFixed(2) || "0.00"
                        )
                    ),
                  ]
                )
              : _vm._e(),
            (_vm.orderMessage.afterType == 1 ||
              _vm.orderMessage.afterType == 2) &&
            _vm.orderMessage.orderAfterDetailList
              ? _c(
                  "span",
                  { staticStyle: { color: "#666666", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "商品总价：￥" +
                        _vm._s(
                          Number(
                            _vm.orderMessage.orderAfterDetailList[0]
                              .retailPrice *
                              _vm.orderMessage.orderAfterDetailList[0]
                                .afterQuantity
                          ).toFixed(2) || "0.00"
                        )
                    ),
                  ]
                )
              : _vm._e(),
            _vm.orderMessage.orderInfo && _vm.orderMessage.afterType == 0
              ? _c(
                  "span",
                  { staticStyle: { color: "#666666", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "运费：￥" +
                        _vm._s(_vm.orderMessage.orderInfo.freightAmount || 0)
                    ),
                  ]
                )
              : _vm._e(),
            (_vm.orderMessage.afterType == 1 ||
              _vm.orderMessage.afterType == 2) &&
            _vm.orderMessage.orderAfterDetailList
              ? _c(
                  "span",
                  { staticStyle: { color: "#666666", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "运费：￥" +
                        _vm._s(
                          Number(
                            _vm.orderMessage.orderAfterDetailList[0]
                              .freightAmount
                          ).toFixed(2) || "0.00"
                        )
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "span",
              { staticStyle: { color: "red", "margin-right": "15px" } },
              [
                _vm._v(
                  "优惠：￥" +
                    _vm._s(
                      _vm.orderMessage.discountAmount
                        ? Number(_vm.orderMessage.discountAmount).toFixed(2)
                        : "0.00"
                    )
                ),
              ]
            ),
            _vm.orderMessage.afterType == 0
              ? _c(
                  "span",
                  { staticStyle: { color: "#444", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "应付：￥" +
                        _vm._s(Number(_vm.orderMessage.refundMoney).toFixed(2))
                    ),
                  ]
                )
              : _vm._e(),
            (_vm.orderMessage.afterType == 1 ||
              _vm.orderMessage.afterType == 2) &&
            _vm.orderMessage.orderAfterDetailList
              ? _c(
                  "span",
                  { staticStyle: { color: "#444", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "应付：￥" +
                        _vm._s(
                          Number(
                            _vm.orderMessage.orderAfterDetailList[0]
                              .refundMoney +
                              _vm.orderMessage.orderAfterDetailList[0]
                                .freightAmount
                          ).toFixed(2)
                        )
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "span",
              { staticStyle: { color: "#6190ed", "margin-right": "15px" } },
              [
                _vm._v(
                  "（实付：￥" +
                    _vm._s(Number(_vm.orderMessage.refundMoney).toFixed(2)) +
                    "）"
                ),
              ]
            ),
            _vm.orderMessage.afterType == 0 || _vm.orderMessage.afterType == 1
              ? _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    "应退款金额：￥" +
                      _vm._s(Number(_vm.orderMessage.refundMoney).toFixed(2))
                  ),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "afterSaleBox" }, [
            _vm._m(3),
            _c("div", { staticClass: "afterSaleBox_item" }, [
              _c("div", { staticClass: "message" }, [
                _c("p", [
                  _c("span", [_vm._v("退款编号:")]),
                  _c("span", { staticClass: "message_value" }, [
                    _vm._v(_vm._s(_vm.orderMessage.afterNo)),
                  ]),
                ]),
                _c("p", [
                  _c("span", [_vm._v("售后类型:")]),
                  _c("span", { staticClass: "message_value" }, [
                    _vm._v(_vm._s(_vm.orderMessage.afterTypeLabel)),
                  ]),
                ]),
                _c("p", [
                  _c("span", [_vm._v("售后原因:")]),
                  _c("span", { staticClass: "message_value" }, [
                    _vm._v(_vm._s(_vm.orderMessage.afterReasonLabel)),
                  ]),
                ]),
                _c("p", [
                  _c("span", [_vm._v("售后说明:")]),
                  _c("span", { staticClass: "message_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.afterRemark
                          ? _vm.orderMessage.afterRemark
                          : "-"
                      )
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "imgbox" },
                [
                  _c("span", { staticClass: "imgbox_title" }, [
                    _vm._v("图片："),
                  ]),
                  _vm._l(_vm.imgs, function (item, index) {
                    return _c("el-image", {
                      key: index,
                      staticClass: "img_item",
                      staticStyle: { cursor: "pointer" },
                      attrs: { src: item, lazy: "" },
                      on: {
                        click: function ($event) {
                          return _vm.look(item)
                        },
                      },
                    })
                  }),
                ],
                2
              ),
            ]),
            _vm.orderMessage.afterType != 2
              ? _c("div", { staticClass: "tuikuan" }, [
                  _c("span", { staticClass: "tuikuan_status" }, [
                    _vm._v(
                      _vm._s(
                        _vm.type == "accomplish"
                          ? "退款成功"
                          : "" || _vm.type == "afterSaleclose"
                          ? "退款失败"
                          : ""
                      )
                    ),
                  ]),
                  _vm.orderMessage.status == 1 ||
                  _vm.orderMessage.status == 2 ||
                  _vm.orderMessage.status == 7 ||
                  _vm.orderMessage.status == 3 ||
                  _vm.orderMessage.status == 4 ||
                  _vm.orderMessage.status == 5
                    ? _c("span", { staticClass: "money" }, [
                        _vm._v("已退款金额:￥0.00"),
                      ])
                    : _c("span", { staticClass: "money" }, [
                        _vm._v(
                          "已退款金额:￥" + _vm._s(_vm.orderMessage.refundMoney)
                        ),
                      ]),
                ])
              : _vm._e(),
          ]),
          (_vm.routeQuery.afterType == 2 &&
            (_vm.orderMessage.status == 3 ||
              _vm.orderMessage.status == 4 ||
              _vm.orderMessage.status == 5 ||
              _vm.orderMessage.status == 6 ||
              _vm.orderMessage.status == 8)) ||
          (_vm.routeQuery.afterType == 1 &&
            (_vm.orderMessage.status == 3 ||
              _vm.orderMessage.status == 4 ||
              _vm.orderMessage.status == 5 ||
              _vm.orderMessage.status == 8))
            ? _c("div", { staticClass: "afterSaleBox" }, [
                _vm._m(4),
                _c("div", { staticClass: "afterSaleBox_item" }, [
                  _c("div", { staticClass: "message" }, [
                    _c("p", [
                      _c("span", [_vm._v("退款地址")]),
                      _vm.backInfo1
                        ? _c("span", { staticClass: "message_value" }, [
                            _vm._v(_vm._s(_vm.backInfo1.postAddress)),
                          ])
                        : _vm._e(),
                    ]),
                    _c("p", [
                      _c("span", [_vm._v("退货电话")]),
                      _vm.backInfo1
                        ? _c("span", { staticClass: "message_value" }, [
                            _vm._v(_vm._s(_vm.backInfo1.postContact)),
                          ])
                        : _vm._e(),
                    ]),
                    _c("p", [
                      _c("span", [_vm._v("退货联系人")]),
                      _vm.backInfo1
                        ? _c("span", { staticClass: "message_value" }, [
                            _vm._v(_vm._s(_vm.backInfo1.postName)),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "botton_btn" }, [
        (_vm.approveStatus || _vm.afterSaleMessage.subsetStatus == 1) &&
        _vm.parArray.indexOf("afterAuditCode") != -1 &&
        this.auditState == true
          ? _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "whiteBtn",
                    attrs: { type: "primary", plain: "" },
                    on: { click: _vm.handlerAudit },
                  },
                  [_vm._v("审核")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "售后申请",
            visible: _vm.isApplyDialog,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isApplyDialog = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v("是否审核通过"),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.radio,
                    callback: function ($$v) {
                      _vm.radio = $$v
                    },
                    expression: "radio",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("通过")]),
                  _c("el-radio", { attrs: { label: "2" } }, [_vm._v("驳回")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.radio == 2
            ? _c(
                "div",
                { staticStyle: { display: "flex", "margin-top": "10px" } },
                [
                  _c("div", [_vm._v("备注")]),
                  _c(
                    "div",
                    { staticStyle: { width: "90%", "margin-left": "10px" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "textarea",
                          maxlength: "200",
                          rows: 3,
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.remark,
                          callback: function ($$v) {
                            _vm.remark = $$v
                          },
                          expression: "remark",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.radio == 1
            ? _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                _vm._v("选择退货地址"),
              ])
            : _vm._e(),
          _vm.radio == 1
            ? _c(
                "el-table",
                {
                  attrs: { data: _vm.gridData, border: "" },
                  on: { "row-click": _vm.rowClick },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "select", width: "50" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: scope.row.id },
                                  model: {
                                    value: _vm.radioIdSelect,
                                    callback: function ($$v) {
                                      _vm.radioIdSelect = $$v
                                    },
                                    expression: "radioIdSelect",
                                  },
                                },
                                [_vm._v(" ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3374867373
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "收货人姓名", width: "200" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "phone", label: "收货人电话", width: "200" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "address", label: "收货地址" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isApplyDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveApply()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "物流信息",
            visible: _vm.dialogLook,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogLook = $event
            },
          },
        },
        [
          _c("StepLogistics", {
            attrs: { stepProgress: _vm.logisticsMessage },
          }),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogLook = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogLook = false
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isInfo,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isInfo = $event
            },
          },
        },
        [
          [
            _c("div", { staticStyle: { "font-size": "20px" } }, [
              _vm._v("是否确认收货?"),
            ]),
            _vm.orderMessage.status == "6"
              ? _c("div", [
                  _vm._v(" 请确认平台用户是否收货，该操作不可修改！ "),
                ])
              : _c("div", [_vm._v("请确认仓库收货，该操作不可修改！")]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isInfo = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.submitInfo } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.dialogForm,
                    "label-width": "80px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "物流公司", prop: "logisticsCompany" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择物流公司",
                            filterable: "",
                          },
                          model: {
                            value: _vm.dialogForm.logisticsCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogForm, "logisticsCompany", $$v)
                            },
                            expression: "dialogForm.logisticsCompany",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.courier_company,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "物流单号", prop: "logisticsNumber" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入物流单号" },
                        model: {
                          value: _vm.dialogForm.logisticsNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogForm, "logisticsNumber", $$v)
                          },
                          expression: "dialogForm.logisticsNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible1, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible1 = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              width: "100%",
              fit: "contain",
              src: _vm.dialogImageUrl,
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contentDetails" }, [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
        },
        [_c("div", { staticClass: "title titleblue" }, [_vm._v("售后详情")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "order_details_box" }, [
      _c("div", { staticClass: "order_details_item" }, [
        _c("span", { staticClass: "order_details_title" }, [
          _vm._v("支付方式"),
        ]),
        _c("span", { staticClass: "order_details_value" }, [
          _vm._v("在线支付"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "titleBtn" }, [
      _c(
        "div",
        { staticClass: "title", staticStyle: { "margin-bottom": "20px" } },
        [_vm._v("商品信息")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "afterSaleBox_item" }, [
      _c("div", { staticClass: "afterSaleBox_title" }, [_vm._v("售后信息")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "afterSaleBox_item" }, [
      _c("div", { staticClass: "afterSaleBox_title" }, [_vm._v("寄回信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }